import { render, staticRenderFns } from "./Designated.vue?vue&type=template&id=cb6097f8&scoped=true"
import script from "./Designated.vue?vue&type=script&lang=js"
export * from "./Designated.vue?vue&type=script&lang=js"
import style0 from "./Designated.vue?vue&type=style&index=0&id=cb6097f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6097f8",
  null
  
)

export default component.exports